import React, { useState } from 'react';
import { Alert, InputGroup } from 'reactstrap';
import Button from '../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import { TemplateFormLabel } from '../TemplateFormLabel/TemplateFormLabel';
import { TemplateModal } from '../TemplateModal/TemplateModal';

type Props = {
  searchToken?: string;
  onClose: Function;
};

const copyToClipboard = (str: string) => {
  const el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

export const CopyTemplateCode = ({ searchToken, onClose }: Props) => {
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const onCopy = () => {
    if (searchToken) {
      copyToClipboard(searchToken);
    }
    setIsAlertOpen(true);
  };

  const onAlertClose = () => {
    setIsAlertOpen(false);
  };

  return (
    <TemplateModal isOpen={true}>
      <TemplateModal.Header toggle={onClose}>
        Template code
        <TemplateModal.SubHeader>
          Copy your Template Code below and use it to share your Chatbot with
          colleagues and other Customers.ai users.
        </TemplateModal.SubHeader>
      </TemplateModal.Header>
      <TemplateModal.Body>
        <TemplateFormLabel>
          <InputGroup style={{ marginBottom: 32 }}>
            <input name="name" value={searchToken} onChange={() => {}} />
            <Button blue onClick={onCopy}>
              Copy
            </Button>
          </InputGroup>
        </TemplateFormLabel>
        <Alert color="success" isOpen={isAlertOpen} toggle={onAlertClose}>
          The template code copied!
        </Alert>
      </TemplateModal.Body>
    </TemplateModal>
  );
};
